(ns bp-clients.tv-app.common.components.tabs
  "Tab component, with state control"
  (:require
   [bp-libs.design-system.components.carousel :refer [carousel]]
   [bp-libs.design-system.components.filter-tabs :refer [filter-item]]))

(defn- bff-tab->ui-tab [active-tab-index tab-index bff-tab]
  ^{:key (str "tab-" (:label bff-tab))}
  [filter-item {:display-name (:label bff-tab)
                :selected?    (= @active-tab-index tab-index)
                :on-click     #(reset! active-tab-index tab-index)
                :on-focus     #(.scrollIntoView (-> % .-target)
                                                (clj->js {:block "start"
                                                          :inline "center"
                                                          :behavior "smooth"}))}])

(defn tabs [tabs active-tab-index _active-card-index]
  ;; TODO trsnaformX to tab AND card (inside tab)
  ;; using active-tab-index and active-card-index
  (let [tabs-component-items (doall (map-indexed (partial bff-tab->ui-tab active-tab-index) tabs))
        active-tab           (nth tabs @active-tab-index)]
    [:div {:class ["flex flex-col w-full"
                   "space-y-6"]}
     ;; carousel of labels. the name :thumbs is not good.
     [carousel {:thumbs tabs-component-items :dynamic-step? true}]
     (:carousel active-tab)]))
